export default __webpack_public_path__ + "static/media/banking-bot.2c23876f.png";